import './init-aos';
import './init-carousel';
import './init-mobile-carousel';
import './init-animations';
import './init-nav-sticky';
import './init-smooth-scroll';
if (document.querySelector('.js-ds-product-feature')) {
    import(/* webpackChunkName: "product-features" */ './init-product-features');
}
if (document.querySelector('.js-accessories-picker')) {
    import(/* webpackChunkName: "accessories-picker" */ './init-accessories-picker');
}
if (document.querySelector('.js-input-image')) {
    import(/* webpackChunkName: "input-image" */ './init-input-image');
}
if (document.querySelector('.js-modal')) {
    import(/* webpackChunkName: "modal" */ './init-modal');
}
if (document.querySelector('.js-product-carousel')) {
    import(/* webpackChunkName: "product-carousel" */ './init-tiny-slider');
}
if (document.querySelector('.js-variant-link')) {
    import(/* webpackChunkName: "product-detail-variants" */ './init-product-detail-variants');
}
if (document.querySelector('.js-mpps')) {
    import(/* webpackChunkName: "mpps-banner" */ './init-mpps-banner');
}
if (document.querySelector('.js-selector-tools')) {
    import(/* webpackChunkName: "selector-tools" */ './init-selector-tools');
}
if (document.querySelector('.js-review-scroll')) {
    import(/* webpackChunkName: "review-scroll" */ './init-review-scroll');
}
if (document.querySelector('.js-step-by-step-tab')) {
    import(/* webpackChunkName: "step-by-step-tabs" */ './init-tabs');
}
if (document.querySelector('.js-fdr-modal-form')) {
    import(/* webpackChunkName: "fan-de-ryobi" */ './fan-de-ryobi/init-form');
}
if (document.querySelector('.js-ds-accordion')) {
    import(/* webpackChunkName: "accordion" */ './init-accordion');
}
if (document.querySelector('.js-scroll-to-products')) {
    import(/* webpackChunkName: "scroll-to-products" */ './init-scroll-to-products');
}
if (document.querySelector('.js-float-scroll-range')) {
    import(/* webpackChunkName: "scroll-to-products" */ './init-scroll-to-range');
}
if (document.querySelector('.js-video-carousel-container')) {
    import(/* webpackChunkName: "video-carousel" */ './init-video-carousel');
}
if (document.querySelector('.js-ds-video-thumbnail')) {
    import(/* webpackChunkName: "video-modal" */ './init-video-modal');
}
if (document.querySelector('.js-battery-carousel')) {
    import(/* webpackChunkName: "battery-carousel" */ './init-battery-carousel');
}
if (document.querySelector('.js-fs-image-slider')) {
    import(/* webpackChunkName: "image-compare" */ './init-image-compare');
}
if (document.querySelector('.js-mp-scrolling-container')) {
    import(/* webpackChunkName: "scrolling-banner" */ './init-scrolling-banner');
}
if (document.querySelector('.js-calendar-tab')) {
    import(/* webpackChunkName: "calendar-tabs" */ './init-calendar');
}
if (document.querySelector('.js-sold-as-carousel')) {
    import(/* webpackChunkName: "sold-as-carousel" */ './init-sold-as-carousel');
}
if (document.querySelector('.js-disable-right-click')) {
    import(/* webpackChunkName: "right-click" */ './init-right-click');
}
if (document.querySelector('.js-input-file')) {
    import(/* webpackChunkName: "input-file" */ './init-input-file');
}
if (document.querySelector('.instrument-guide__tabs')) {
    import(/* webpackChunkName: "instrument-guide" */ './init-instrument-carousel');
}
if (document.querySelector('.js-fit-text')) {
    import(/* webpackChunkName: "fitty" */ './init-fit-text');
}
if (document.querySelector('.js-instruments-nav')) {
    import(/* webpackChunkName: "instruments-nav" */ './init-instruments-nav');
}
if (document.querySelector('.js-scrub-carousel')) {
    import(/* webpackChunkName: "scrubber-carousel" */ './init-scrubber-carousel');
}
if (document.querySelector('.js-select-head')) {
    import(/* webpackChunkName: "scrub-head-selector" */ './init-scrub-head-selector');
}
if (document.querySelector('.js-focus-navigation')) {
    import(/* webpackChunkName: "focus-navigation" */ './init-focus-navigation');
}
if (document.querySelector('.js-classification-button')) {
    import(/* webpackChunkName: "classification-table" */ './init-classification-table');
}
if (document.querySelector('.js-tabbed-category')) {
    import(/* webpackChunkName: "tabbed-tips" */ './init-tabbed-tips');
}
if (document.querySelector('.js-jump-page-nav')) {
    import(/* webpackChunkName: "jump-page-nav" */ './jump-page-nav');
}
if (document.querySelector('.js-roboyagi-navigation')) {
    import(/* webpackChunkName: "roboyagi-nav" */ './init-roboyagi-navigation');
}
